import {useState} from 'react'
import {IconButton, Collapse} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {
  StyledAlert,
  StyledListButton,
  StyledLink,
  StyledAlertTitle,
  StyledListTypography,
  MainBox
} from './NotificationBannerStyle'
import buttonTitles from '../../../appConfig/buttonTitles.config.json'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'

const NotificationBanner = ({
  isAdminpanelOpen,
  message,
  type = 'warning',
  hasList = false,
  list,
  open,
  handleBannerClose,
  handleAdminBannerClose,
  ariaLabel = null
}) => {
  const [display, setDisplay] = useState(1)

  const handleShowMore = (itemsLength) => {
    setDisplay(display + (itemsLength - 1))
  }

  const handleShowLess = () => {
    setDisplay(1)
  }

  return (
    <MainBox isAdminpanelOpen={isAdminpanelOpen}>
      <Collapse in={open}>
        <StyledAlert
          sx={{
            mb: 2
          }}
          tabIndex={0}
          severity={type}
          variant='alert'
          aria-label={ariaLabel || message}
          action={
            <IconButton
              title={buttonTitles.notificationTitle}
              aria-label='close'
              size='small'
              onClick={() => {
                if (isAdminpanelOpen) {
                  handleAdminBannerClose()
                } else {
                  handleBannerClose()
                }
              }}
            >
              <CloseIcon style={{color: (theme) => theme.palette.hpAccentBlack, fontSize: 'inherit'}} />
            </IconButton>
          }
        >
          <StyledAlertTitle variant='titleSmall'>{message}</StyledAlertTitle>
          {hasList && (
            <div>
              {list.slice(0, display).map((obj) => {
                const key = obj.id || `${obj.CLIENT_ID}${obj.PROJECT_ID}`
                return (
                  <StyledListTypography
                    key={key}
                    tabIndex={0}
                    aria-label={`${obj.FIRST_NAME} ${obj.LAST_NAME} user, with client name ${
                      obj.CLIENT_NAME
                    } and project name ${obj.PROJECT_NAME}, Access ends ${dayjs(obj.END_DATE).format('MM/DD/YY')}`}
                  >
                    {obj.FIRST_NAME} {obj.LAST_NAME}, {` `}
                    <StyledLink
                      href={`/adminpanel/client/${obj.CLIENT_ID}/project/${obj.PROJECT_ID}`}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {obj.CLIENT_NAME} - {obj.PROJECT_NAME}
                    </StyledLink>
                    , Access ends {dayjs(obj.END_DATE).format('MM/DD/YY')}.
                  </StyledListTypography>
                )
              })}
              {list.length > display && (
                <StyledListButton
                  onClick={() => {
                    handleShowMore(list.length)
                  }}
                >
                  See Full List
                </StyledListButton>
              )}

              {list.length === display && (
                <StyledListButton
                  onClick={() => {
                    handleShowLess()
                  }}
                >
                  See Less
                </StyledListButton>
              )}
            </div>
          )}
        </StyledAlert>
      </Collapse>
    </MainBox>
  )
}

NotificationBanner.propTypes = {
  isAdminpanelOpen: PropTypes.bool,
  message: PropTypes.string,
  type: PropTypes.string,
  hasList: PropTypes.bool,
  list: PropTypes.any,
  open: PropTypes.bool,
  handleBannerClose: PropTypes.func,
  handleAdminBannerClose: PropTypes.func,
  ariaLabel: PropTypes.string
}
export default NotificationBanner
